/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Title_2Inputs */

const en_svc_research_title_2 = /** @type {(inputs: Svc_Research_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`that show their work.`)
};

const lv_svc_research_title_2 = /** @type {(inputs: Svc_Research_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kas parāda savu darbu.`)
};

/**
* | output |
* | --- |
* | "that show their work." |
*
* @param {Svc_Research_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_title_2 = /** @type {((inputs?: Svc_Research_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_title_2(inputs)
	return en_svc_research_title_2(inputs)
});